import store from '@/store'

export const toggleBodyTheme = () => {
  const theme = store.getters.getTheme || 'light'
  const oldClass = theme === 'dark' ? 'light' : 'dark'

  document.body.classList.remove(oldClass)
  document.body.classList.add(theme)
}
